// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1NLuW","icon":"style_icon__3YwUm"};